/* tslint:disable:jsx-no-lambda WI:47750 */
import * as React from 'react';
import type { RecipientMailtipInfo } from './SingleRecipientAutomaticReplyDetails';
import RemoveRecipientButton from './RemoveRecipientButton';
import type EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import RecipientMailtipMessageRow from './RecipientMailtipMessageRow';
import type ColorScheme from 'owa-color-utils/lib/ColorScheme';
import getOOFMessage from '../utils/getOOFMessage';

export interface MultiRecipientAutomaticReplyDetailsProps {
    colorScheme?: ColorScheme;
    onRemove: (recipient: EmailAddressWrapper[]) => void;
    recipientsInfo: RecipientMailtipInfo[];
}

const MultiRecipientAutomaticReplyDetails = (props: MultiRecipientAutomaticReplyDetailsProps) => {
    return (
        <>
            {props.recipientsInfo.map(recipientInfo => (
                <div key={recipientInfo.recipient.EmailAddress}>
                    <RecipientMailtipMessageRow
                        recipient={recipientInfo.recipient}
                        recipientMessage={getOOFMessage(recipientInfo.automaticReply)}
                    />
                    <RemoveRecipientButton
                        colorScheme={props.colorScheme}
                        onClick={(recipient: EmailAddressWrapper) => props.onRemove([recipient])}
                        recipient={recipientInfo.recipient}
                    />
                </div>
            ))}
        </>
    );
};

export default MultiRecipientAutomaticReplyDetails;
